import Image from 'next/image';
import { FC } from 'react';

export interface ImageFloatProps {
  uid: any;
  image: any;
  image_size: any;
  float: any;
}

const ImageFloat: FC<ImageFloatProps> = ({ uid, image, image_size, float }) => {
  let aspectImage;
  let floatImage;

  switch (image_size) {
    case '4:3':
      aspectImage = 'aspect-[4/3]';
      break;
    case '16:9':
      aspectImage = 'aspect-[16/9]';
      break;
    case '21:9':
      aspectImage = 'aspect-[21/9]';
      break;
    default:
      aspectImage = '';
      break;
  }

  switch (float) {
    case 'left':
      floatImage = 'md:float-left';
      break;
    case 'right':
      floatImage = 'md:float-right';
      break;
    default:
      floatImage = '';
      break;
  }

  return (
    <div key={uid} className={`not-prose my-2 w-full md:w-1/2 ${floatImage}`}>
      <div className={`relative ${aspectImage}`}>
        <Image
          title={image?.title}
          alt={image?.alt}
          src={image?.filename}
          layout="fill"
          objectFit="cover"
          blurDataURL={`${image?.filename}/m/100x0/filters:blur(10)`}
          placeholder="blur"
        />
      </div>
      <p className="!m-0 pt-2 font-mono text-xs text-neutral-500 empty:hidden lg:text-right">
        {image?.title && `${image?.title}`}
        {image?.copyright && ` © ${image?.copyright}`}
        {image?.source && ` / ${image?.source}`}
      </p>
    </div>
  );
};

export default ImageFloat;
